// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/dragndrop.css
// module id = Xqa9
// module chunks = 1